import React from 'react';
import {
    Bell,
    CheckCircle,
    AlertTriangle,
    Sparkles,
    FileText,
    Clock
} from 'lucide-react';
import './NotificationDropdown.css';
import { formatLocalDateTime } from '../../../utils/date';
import { safeRenderText } from '../../../utils/safeRenderText';

const NotificationDropdown = ({
    notifications,
    loading,
    onMarkAllRead,
    onNotificationClick,
    onClose
}) => {

    const getIcon = (type) => {
        switch (type?.toLowerCase()) {
            case 'info':
            case 'success':
                return <CheckCircle size={18} />;
            case 'warning':
            case 'error':
                return <AlertTriangle size={18} />;
            case 'ai':
            case 'sparkle':
                return <Sparkles size={18} />;
            case 'document':
            case 'rfp':
                return <FileText size={18} />;
            default:
                return <Bell size={18} />;
        }
    };

    const getIconClass = (type) => {
        switch (type?.toLowerCase()) {
            case 'info':
            case 'success': return 'icon-success';
            case 'warning':
            case 'error': return 'icon-warning';
            case 'ai': return 'icon-ai';
            case 'rfp':
            case 'document': return 'icon-info';
            default: return 'icon-default';
        }
    };

    const formatTime = (dateString) => {
        return formatLocalDateTime(dateString);
    };

    return (
        <div className="notifications-dropdown">
            <div className="notifications-header">
                <h3>Notifications</h3>
                <button className="mark-all-read" onClick={onMarkAllRead}>
                    Mark all read
                </button>
            </div>

            <div className="notifications-list">
                {loading ? (
                    <div className="loading-spinner-container">
                        <div className="spinner"></div>
                    </div>
                ) : (!Array.isArray(notifications) || notifications.length === 0) ? (
                    <div className="no-notifications">
                        <Bell size={40} />
                        <p>No notifications yet</p>
                    </div>
                ) : (
                    <>
                        {notifications.map((notif) => (
                            <div
                                key={notif._id || notif.id}
                                className={`notification-item ${(notif.read_status === false || notif.is_read === false) ? 'unread' : ''}`}
                                onClick={() => onNotificationClick(notif)}
                            >
                                <div className={`notification-icon-wrapper ${getIconClass(notif.type)}`}>
                                    {getIcon(notif.type)}
                                </div>
                                <div className="notification-content">
                                    <div className="notification-message">
                                        {(() => {
                                            let messageText = '';
                                            if (typeof notif.message === 'string') {
                                                messageText = notif.message;
                                            } else if (notif.message && typeof notif.message === 'object') {
                                                const author = notif.message.author_display_name || 'System';
                                                const content = safeRenderText(notif.message.content);
                                                messageText = `New message from ${author}: "${content}"`;
                                            } else if (notif.content) {
                                                messageText = typeof notif.content === 'string' ? notif.content : safeRenderText(notif.content);
                                            } else {
                                                messageText = 'New Notification';
                                            }

                                            const textStr = safeRenderText(messageText);

                                            if (textStr.includes('EXCEEDED TIMELINE')) {
                                                return (
                                                    <>
                                                        {textStr.replace('EXCEEDED TIMELINE', '')}
                                                        <span className="notif-exceeded-badge">EXCEEDED TIMELINE</span>
                                                    </>
                                                );
                                            }
                                            return textStr;
                                        })()}
                                    </div>
                                    <div className="notification-meta">
                                        <span className="notification-time">
                                            <Clock size={11} />
                                            {formatTime(notif.created_at)}
                                        </span>
                                    </div>
                                </div>
                                {(notif.read_status === false || notif.is_read === false) && <div className="unread-dot"></div>}
                            </div>
                        ))}
                        <div className="notifications-end-indicator">
                            <span className="end-indicator-text">You've reached the end of your notifications</span>
                        </div>
                    </>
                )}
            </div>

            {/* <div className="notifications-footer">
                <button className="view-all-btn">
                    View All Notifications
                </button>
            </div> */}
        </div>
    );
};

export default NotificationDropdown;
